/*
 * @Description:
 * @Date: 2023/4/19 上午11:43:11
 */
export const route = [
  /** 项目详情入口：req-left 跳转，无 parentPath，走项目原逻辑 */
  {
    path: '/main/form-add-list',
    name: 'form-add-list',
    meta: {
      title: '表单',
      isMenuSkip: true
    },
    component: () => import('../views/form-add-list.vue')
  },
  /** 表单管理入口：form-manage 列表跳转，面包屑指向 form-manage-list */
  {
    path: '/main/form-add-list-edit',
    name: 'form-add-list-edit',
    meta: {
      title: '表单',
      parentPath: '/main/form-manage-list'
    },
    component: () => import('../views/form-add-list.vue')
  },
  /** 智能辅助医学表单工作台（对齐产品 demo） */
  {
    path: '/main/form-add-ai-wizard',
    name: 'form-add-ai-wizard',
    meta: {
      title: '智能辅助医学表单',
      parentPath: '/main/form-manage-list',
      noLayout: true
    },
    component: () => import('../views/form-add-ai-wizard.vue')
  },
  /** 关联表单入口：项目详情关联表单新建，跳过菜单匹配 */
  {
    path: '/main/form-add-list-edit-custom',
    name: 'form-add-list-edit-custom',
    meta: {
      title: '表单',
      isMenuSkip: true
    },
    component: () => import('../views/form-add-list.vue')
  },
  /** 关联表单入口：项目详情关联表单智能辅助，跳过菜单匹配 */
  {
    path: '/main/form-add-ai-wizard-custom',
    name: 'form-add-ai-wizard-custom',
    meta: {
      title: '智能辅助医学表单',
      isMenuSkip: true,
      noLayout: true
    },
    component: () => import('../views/form-add-ai-wizard.vue')
  }
];
